import { render, staticRenderFns } from "./TuberCulinSkin.vue?vue&type=template&id=40e8f0ee&scoped=true&"
import script from "./TuberCulinSkin.vue?vue&type=script&lang=js&"
export * from "./TuberCulinSkin.vue?vue&type=script&lang=js&"
import style0 from "./TuberCulinSkin.vue?vue&type=style&index=0&id=40e8f0ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8f0ee",
  null
  
)

export default component.exports